import { GlobalConfiguration } from '../../models/GlobalConfiguration';
import BackendService from 'BackendService';

class GlobalConfigurationCache {
  private config: GlobalConfiguration | null = null;

  /**
   * Returns the cached config or fetches it from the backend if missing.
   */
  async getConfig(): Promise<GlobalConfiguration> {
    // If we have cached config, return it
    if (this.config) {
      return this.config;
    }

    // Otherwise, fetch from backend
    const cfg = await new BackendService().getGlobalConfiguration();
    this.config = cfg;
    return cfg;
  }

  /**
   * Set the config directly (useful for public routes that receive config in API response)
   */
  setConfig(cfg: GlobalConfiguration): void {
    this.config = cfg;
  }

  /**
   * Forces the next `getConfig()` to re-fetch from the backend.
   */
  clearCache(): void {
    this.config = null;
  }
}

const globalConfigurationCache = new GlobalConfigurationCache();
export { globalConfigurationCache };
